module.exports = __webpack_public_path__ + "img/card.8b620bac.png";